
// designs
import emixDesign1 from '../../assets/images/DesignerProjects/emix-design-1.jpg'
import emixDesign2 from '../../assets/images/DesignerProjects/emix-design-2.jpg'
import emixDesign3 from '../../assets/images/DesignerProjects/emix-design-3.jpg'
import emixDesign4 from '../../assets/images/DesignerProjects/emix-design-4.jpg'
import emixDesign5 from '../../assets/images/DesignerProjects/emix-design-5.jpg'
// import emixDesign6 from '../../assets/images/DesignerProjects/emix-design-6.jpeg'
import emixDesign7 from '../../assets/images/DesignerProjects/emix-design-7.jpg'
import emixDesign8 from '../../assets/images/DesignerProjects/emix-design-8.jpg'
import emixDesign9 from '../../assets/images/DesignerProjects/emix-design-9.jpg'
import emixDesign10 from '../../assets/images/DesignerProjects/emix-design-10.jpg'
import emixDesign11 from '../../assets/images/DesignerProjects/emix-design-11.jpg'
import emixDesign12 from '../../assets/images/DesignerProjects/emix-design-12.jpg'
import emixDesign13 from '../../assets/images/DesignerProjects/emix-design-13.jpg'
import emixDesign14 from '../../assets/images/DesignerProjects/emix-design-14.jpg'
import emixDesign15 from '../../assets/images/DesignerProjects/emix-design-15.jpeg'
// import emixDesign16 from '../../assets/images/DesignerProjects/emix-design-16.png'
import emixDesign17 from '../../assets/images/DesignerProjects/emix-design-17.jpeg'
import emixDesign18 from '../../assets/images/DesignerProjects/emix-design-18.jpeg'
import emixDesign19 from '../../assets/images/DesignerProjects/emix-design-19.jpeg'
import emixDesign20 from '../../assets/images/DesignerProjects/emix-design-20.jpeg'
import emixDesign21 from '../../assets/images/DesignerProjects/emix-design-21.png'
import emixDesign22 from '../../assets/images/DesignerProjects/emix-design-22.jpeg'
import emixDesign23 from '../../assets/images/DesignerProjects/emix-design-23.jpeg'
import emixDesign24 from '../../assets/images/DesignerProjects/emix-design-24.jpeg'
import emixDesign25 from '../../assets/images/DesignerProjects/emix-design-25.png'
// import emixDesign26 from '../../assets/images/DesignerProjects/emix-design-26.jpg'


export const designs = [
     emixDesign1,
     emixDesign2,
     emixDesign3,
     emixDesign4,
     emixDesign5,
     emixDesign7,
     emixDesign8,
     emixDesign9,
     emixDesign10,
     emixDesign11,
     emixDesign12,
     emixDesign13,
     emixDesign14,
     emixDesign15,
     emixDesign17,
     emixDesign18,
     emixDesign19,
     emixDesign20,
     emixDesign21,
     emixDesign22,
     emixDesign23,
     emixDesign24,
     emixDesign25,
];